import axios from 'axios';
import {
  GET_MAIN_SLIDES,
  GET_MOVIES_SLIDES,
  GET_CARTOONS_SLIDES,
  GET_CLIPS_SLIDES,
  GET_PODCASTS_SLIDES,
  GET_AUDIOBOOKS_SLIDES,
  GET_TV_SLIDES,
  GET_SERIALS_SLIDES,
} from '../constants';

// Main slider
export const getMainSlidesSuccess = response => ({
  type: GET_MAIN_SLIDES,
  response,
});

export const getMainSlides = () => dispatch => (
  axios.get('/banners/banners?type=main')
    .then((response) => {
      const tempData = response.data.data;
      const data = {
        status: response.status,
        data: tempData.map((banner) => {
          let route = null;
          switch (banner.type) {
            case 'tv': route = `/tv/${banner.param}`; break;
            case 'radio': route = `/radio/${banner.param}`; break;
            case 'movie': route = `/movies/movie/${banner.param}`; break;
            case 'serial': route = `/serials/serial/${banner.param}`; break;
            case 'podcast': route = `/podcasts/podcast/${banner.param}`; break;
            case 'cartoon': route = `/cartoons/cartoon/${banner.param}`; break;
            case 'audiobook': route = `/audiobooks/audiobook/${banner.param}`; break;
            case 'clip': route = `/clips/clip/${banner.param}`; break;
            default: route = banner.param;
          }

          return {
            ...banner,
            param: route,
          };
        }),
      };
      return dispatch(getMainSlidesSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: [],
      };
      if (error.response) {
        data.status = error.response.status;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getMainSlidesSuccess(data));
    })
);


// Tv slider
export const getTvSlidesSuccess = response => ({
  type: GET_TV_SLIDES,
  response,
});

export const getTvSlides = () => dispatch => (
  axios.get('/banners/banners?type=tv')
    .then((response) => {
      const data = {
        status: response.status,
        data: response.data.data.map(banner => ({
          ...banner,
          param: `/tv/${banner.param}`,
        })),
      };
      return dispatch(getTvSlidesSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: [],
      };
      if (error.response) {
        data.status = error.response.status;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getTvSlidesSuccess(data));
    })
);

// Movie's slider
export const getMoviesSlidesSuccess = response => ({
  type: GET_MOVIES_SLIDES,
  response,
});

export const getMoviesSlides = () => dispatch => (
  axios.get('/banners/banners?type=movie')
    .then((response) => {
      const data = {
        status: response.status,
        data: response.data.data.map(banner => ({
          ...banner,
          param: `/movies/movie/${banner.param}`,
        })),
      };
      return dispatch(getMoviesSlidesSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: [],
      };
      if (error.response) {
        data.status = error.response.status;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getMoviesSlidesSuccess(data));
    })
);

// Cartoon's slider
export const getCartoonsSlidesSuccess = response => ({
  type: GET_CARTOONS_SLIDES,
  response,
});

export const getCartoonsSlides = () => dispatch => (
  axios.get('/banners/banners?type=cartoon')
    .then((response) => {
      const data = {
        status: response.status,
        data: response.data.data.map(banner => ({
          ...banner,
          param: `/cartoons/cartoon/${banner.param}`,
        })),
      };
      return dispatch(getCartoonsSlidesSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: [],
      };
      if (error.response) {
        data.status = error.response.status;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getCartoonsSlidesSuccess(data));
    })
);

// Serials slider
export const getSerialsSlidesSuccess = response => ({
  type: GET_SERIALS_SLIDES,
  response,
});

export const getSerialsSlides = () => dispatch => (
  axios.get('/banners/banners?type=serial')
    .then((response) => {
      const data = {
        status: response.status,
        data: response.data.data.map(banner => ({
          ...banner,
          param: `/serials/serial/${banner.param}`,
        })),
      };
      return dispatch(getSerialsSlidesSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: [],
      };
      if (error.response) {
        data.status = error.response.status;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getSerialsSlidesSuccess(data));
    })
);

// Clips's slider
export const getClipsSlidesSuccess = response => ({
  type: GET_CLIPS_SLIDES,
  response,
});

export const getClipsSlides = () => dispatch => (
  axios.get('/banners/banners?type=clip')
    .then((response) => {
      const data = {
        status: response.status,
        data: response.data.data.map(banner => ({
          ...banner,
          param: `/clips/clip/${banner.param}`,
        })),
      };
      return dispatch(getClipsSlidesSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: [],
      };
      if (error.response) {
        data.status = error.response.status;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getClipsSlidesSuccess(data));
    })
);

// Podcasts slider
export const getPodcastsSlidesSuccess = response => ({
  type: GET_PODCASTS_SLIDES,
  response,
});

export const getPodcastsSlides = () => dispatch => (
  axios.get('/banners/banners?type=podcast')
    .then((response) => {
      const data = {
        status: response.status,
        data: response.data.data.map(banner => ({
          ...banner,
          param: `/podcasts/podcast/${banner.param}`,
        })),
      };
      return dispatch(getPodcastsSlidesSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: [],
      };
      if (error.response) {
        data.status = error.response.status;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getPodcastsSlidesSuccess(data));
    })
);


// Audio book's slider
export const getAudiobooksSlidesSuccess = response => ({
  type: GET_AUDIOBOOKS_SLIDES,
  response,
});

export const getAudiobooksSlides = () => dispatch => (
  axios.get('/banners/banners?type=audiobooks')
    .then((response) => {
      const data = {
        status: response.status,
        data: response.data.data.map(banner => ({
          ...banner,
          param: `/audiobooks/audiobook/${banner.param}`,
        })),
      };
      return dispatch(getAudiobooksSlidesSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: [],
      };
      if (error.response) {
        data.status = error.response.status;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getAudiobooksSlidesSuccess(data));
    })
);

// Music's slider
export const getMusicSlidesSuccess = response => ({
  type: GET_AUDIOBOOKS_SLIDES,
  response,
});

export const getMusicSlides = () => dispatch => (
  axios.get('/banners/banners?type=music')
    .then((response) => {
      const data = {
        status: response.status,
        data: response.data.data,
      };
      return dispatch(getMusicSlidesSuccess(data));
    })
    .catch((error) => {
      const data = {
        status: 0,
        data: [],
      };
      if (error.response) {
        data.status = error.response.status;
      } else if (error.request) {
        data.status = 0;
      } else {
        data.status = 0;
      }
      dispatch(getMusicSlidesSuccess(data));
    })
);
